// Prefix for each day checkbox's id, which must be unique on the page (see the
// `id` prop of UI/Checkbox).
export const OPENING_DAY_CHECKBOX_ID_PREFIX = 'opening-day-';
